// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 공통 변수 (App.css에서 정의하고 여기서 사용) */

.container {
    color: var(--text-color);
  }
  
  .filterContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
    padding: 15px;
    background-color: var(--filter-bg);
    border-radius: 8px;
  }
  
  .filterLabel {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: var(--text-color);
  }
  
  .filterInput,
  .filterSelect {
    margin-left: 5px;
    padding: 5px;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }
  
  .button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    color: white;
    font-size: 14px;
    cursor: pointer;
  }
  
  .buttonPrimary {
    background-color: var(--primary-color);
  }
  
  .buttonSecondary {
    background-color: #6c757d;
  }
  
  .buttonSuccess {
    background-color: var(--success);
  }
  
  .buttonDisabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .statusSummary {
    text-align: center;
    margin-bottom: 15px;
    color: var(--text-color);
  }
  
  .statusSummary span {
    margin-right: 20px;
  }
  
  .statusPass {
    color: var(--success);
  }
  
  .statusFail {
    color: var(--danger);
  }

  .tableScrollWrapper {
    height: calc(100vh - 200px);
    border: 1px solid #ccc;
    margin-top: 2px;
    width: calc(100% - 30px);
    margin: 0 15px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/SensorContainer.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;IACI,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,wBAAwB;EAC1B;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;IACf,wBAAwB;IACxB,cAAc;EAChB","sourcesContent":["/* 공통 변수 (App.css에서 정의하고 여기서 사용) */\r\n\r\n.container {\r\n    color: var(--text-color);\r\n  }\r\n  \r\n  .filterContainer {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 5px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 5px;\r\n    padding: 15px;\r\n    background-color: var(--filter-bg);\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .filterLabel {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    color: var(--text-color);\r\n  }\r\n  \r\n  .filterInput,\r\n  .filterSelect {\r\n    margin-left: 5px;\r\n    padding: 5px;\r\n    font-size: 14px;\r\n    border-radius: 4px;\r\n    border: 1px solid #ccc;\r\n  }\r\n  \r\n  .button {\r\n    padding: 8px 16px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    color: white;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .buttonPrimary {\r\n    background-color: var(--primary-color);\r\n  }\r\n  \r\n  .buttonSecondary {\r\n    background-color: #6c757d;\r\n  }\r\n  \r\n  .buttonSuccess {\r\n    background-color: var(--success);\r\n  }\r\n  \r\n  .buttonDisabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .statusSummary {\r\n    text-align: center;\r\n    margin-bottom: 15px;\r\n    color: var(--text-color);\r\n  }\r\n  \r\n  .statusSummary span {\r\n    margin-right: 20px;\r\n  }\r\n  \r\n  .statusPass {\r\n    color: var(--success);\r\n  }\r\n  \r\n  .statusFail {\r\n    color: var(--danger);\r\n  }\r\n\r\n  .tableScrollWrapper {\r\n    height: calc(100vh - 200px);\r\n    border: 1px solid #ccc;\r\n    margin-top: 2px;\r\n    width: calc(100% - 30px);\r\n    margin: 0 15px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
